import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $BanneredLayout = styled.div<{
  $isNeutralBackground?: boolean;
}>`
  padding-bottom: ${spacing('lg')};
  background-color: ${({ theme, $isNeutralBackground }) =>
    $isNeutralBackground ? theme.systemColors.defaultBackground : undefined};
  min-height: ${({ $isNeutralBackground }) =>
    $isNeutralBackground ? 'calc(100vh - 64px)' : undefined};
`;

export const $HeadingWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  @media ${media.maxWidth.xs} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const $HeadingTitle = styled.div`
  display: block;
`;

export const $HeadingAction = styled.div`
  display: flex;
  @media ${media.maxWidth.xs} {
    margin-top: ${spacing(3.5)};
  }
`;

export const $Title = styled.div<{ $enableServicePortal?: boolean }>`
  color: ${({ theme, $enableServicePortal }) =>
    $enableServicePortal ? 'white' : theme.newUI.defaultColors.heading};
  font-size: ${({ theme }) => theme.tw.font.size['3xl']};
  font-weight: 800;
  margin-bottom: ${spacing('md')};

  @media ${media.maxWidth.xs} {
    display: ${({ $enableServicePortal }) =>
      $enableServicePortal ? 'none' : undefined};
  }
  @media ${media.maxWidth.sm} {
    margin-top: ${spacing(3.5)};
    ${fontStyle('lg')};
  }
`;

export const $Description = styled.div<{ $enableServicePortal?: boolean }>`
  color: ${({ $enableServicePortal, theme }) =>
    $enableServicePortal
      ? theme.systemColors.defaultBackground
      : theme.colors.paragraphTextColor};
  font-weight: ${fontWeight('normal')};
  ${fontStyle('sm')};
  margin-bottom: ${spacing('xs')};
  @media ${media.maxWidth.sm} {
    margin-bottom: unset;
  }

  @media ${media.maxWidth.xs} {
    display: ${({ $enableServicePortal }) =>
      $enableServicePortal ? 'none' : undefined};
  }
`;

export const $ContentWrapper = styled.div``;

export const $Content = styled.div<{
  $enableServicePortal?: boolean;
  $hasBannerUrl?: boolean;
}>`
  margin-top: ${({ $enableServicePortal, $hasBannerUrl }) =>
    $enableServicePortal && $hasBannerUrl
      ? `calc(-1 * ${spacing(21)})`
      : `calc(-1 * ${spacing(11)})`};
  box-shadow: ${({ $enableServicePortal }) =>
    $enableServicePortal ? '0 0 15px 0px rgba(0,0,0,.05)' : undefined};

  @media ${media.maxWidth.md} {
    padding-left: ${spacing(2.5)};
    padding-right: ${spacing(2.5)};
  }

  @media ${media.maxWidth.xs} {
    padding-left: ${spacing(2.5)};
    padding-right: ${spacing(2.5)};
    margin-top: ${({ $enableServicePortal }) =>
      $enableServicePortal ? `calc(-1 * ${spacing(3.5)})` : undefined};
  }
`;
